import { format, utcToZonedTime } from "date-fns-tz"

import DateFnsUtils from "@date-io/date-fns"
import { IUtils } from "@date-io/core/IUtils"
import { Locale } from "date-fns"
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date"
import { MuiPickersContext } from "@material-ui/pickers"
import { MuiPickersUtilsProviderProps } from "@material-ui/pickers/MuiPickersUtilsProvider"
import React from "react"

type Props = MuiPickersUtilsProviderProps & {
  timeZone: string
}

export const MuiPickersTzUtilsProvider = (props: Props) => {
  const { children, utils, locale, timeZone } = props
  const utilsContext = React.useMemo(
    () => new utils({ locale, timeZone }),
    [utils, locale, timeZone],
  ) as IUtils<MaterialUiPickersDate> | null
  return <MuiPickersContext.Provider value={utilsContext} children={children} />
}

export class DateFnsTzUtils extends DateFnsUtils {
  timeZone: string
  constructor({ timeZone, locale }: { timeZone: string; locale: Locale }) {
    super()
    this.timeZone = timeZone
    this.locale = locale
  }

  format(date: number | Date, formatString: string) {
    return format(date, formatString, {
      timeZone: this.timeZone,
      locale: this.locale,
    })
  }

  date(date?: any) {
    if (!date) {
      return utcToZonedTime(new Date(), this.timeZone)
    } else if (typeof date === "string") {
      return utcToZonedTime(new Date(date), this.timeZone)
    }
    return date
  }
}
